export async function print(source: string) {
  const runtimeConfig = useRuntimeConfig()
  const domain = runtimeConfig.public.DOMAIN
  const pdfHost = runtimeConfig.public.PDF_HOST
  const cookie = useCookie('ressources_user_token', {
    maxAge: 3600,
    domain,
  })
  const response = await $fetch(pdfHost, {
    method: 'POST',
    body: JSON.stringify({
      accessToken: cookie?.value,
      centerNumberFooter: true,
      toc: true,
      cover: `${source}/cover/?print=true`,
      source: `${source}/?print=true`,
      headerLine: true,
      headerRight: 'IRCAM',
    }),
  })
  const pdfUrl = URL.createObjectURL(response)
  window.open(pdfUrl, '_blank')
}
